<template>
  <div class="et-switch">
    <label>
      <input type="radio" ref="leftRef" :name="radioName" @click="onClickLeft">
      <span>{{ leftText }}</span>
    </label>
    <label>
      <input type="radio" ref="rightRef" :name="radioName" @click="onClickRight">
      <span>{{ rightText }}</span>
    </label>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: 'right'
  },
  disabled: {
    type: Boolean,
    default: false
  },
  leftText: {
    type: String,
    default: '左'
  },
  rightText: {
    type: String,
    default: '右'
  },
  leftValue: {
    type: String,
    default: 'left'
  },
  rightValue: {
    type: String,
    default: 'right'
  }
})

const emit = defineEmits(['update:modelValue', 'change'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
    emit('change', val)
  }
})

const leftRef = ref(null)
const rightRef = ref(null)
// 生成唯一的 radio name，避免多个组件之间的冲突
const radioName = `direction-switch-${Math.random().toString(36).substr(2, 9)}`

onMounted(() => {
  watch(value, (val) => {
    if (val === props.leftValue) {
      leftRef.value.checked = true
      rightRef.value.checked = false
    } else {
      rightRef.value.checked = true
      leftRef.value.checked = false
    }
  }, {
    immediate: true
  })
})

function onClickLeft() {
  if (props.disabled) {
    return
  }
  value.value = props.leftValue
}

function onClickRight() {
  if (props.disabled) {
    return
  }
  value.value = props.rightValue
}

</script>

<style scoped>
.et-switch {
  user-select: none;
}
.et-switch label {
  font-weight: normal;
}
.et-switch input[type="radio"] {
  display: none;
}
.et-switch input:checked ~ span {
  background-color: #178FFC;
  color: white;
}
.et-switch span {
  padding: 4px 12px;
  border: 1px solid #178FFC;
  cursor: pointer;
  display: inline-block;
  min-width: 40px;
  text-align: center;
}
</style>
